// Imports => Constants
import { ENDPOINTS } from '@constants';

export class GlobalAPI {
  constructor(Client, config) {
    this.Client = Client;
    this.config = config;
  }

  search = (params) => {
    return this.Client.post(ENDPOINTS.GLOBAL.SEARCH, params).then(
      (response) => response.data.data
    );
  };

  chart = (params) => {
    return this.Client.get(ENDPOINTS.GLOBAL.STATISTICS.CHART, { params }).then(
      (response) => response.data.data
    );
  };

  totals = (params) => {
    return this.Client.get(ENDPOINTS.GLOBAL.STATISTICS.TOTALS, { params }).then(
      (response) => response.data.data
    );
  };
}

export default GlobalAPI;
